import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Card, Nav, Tab, Dropdown, Table, Badge, Accordion, useAccordionButton} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { LAYOUT } from 'constants.js';
import HtmlHead from 'components/html-head/HtmlHead';
import BreadcrumbList from 'components/breadcrumb-list/BreadcrumbList';
import { showProgressLoader } from 'components/progress-loader/progressLoaderSlice'
import { showToast } from 'components/workabl-toast';

import CsLineIcons from 'cs-line-icons/CsLineIcons';
import useCustomLayout from 'hooks/useCustomLayout';
import { useWindowSize } from 'hooks/useWindowSize';
import _ from 'lodash';

import Portfolio from './Portfolio';



const PortfolioHome = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  useCustomLayout({ layout: LAYOUT.Boxed });

  const title = 'Portfolio';
  const description = 'Portfolio';

  const breadcrumbs = [
    { to: '', text: 'Home' },
    { to: 'portfolio/', text: 'Portfolio' },
  ];

  const { currentUser } = useSelector((state) => state.currentUser);

  const page_onLoad = async () => {
    dispatch(showProgressLoader(true));
    if(_.isEmpty(currentUser)){
      showToast({ type: 'error', title: 'Oops!! Something went wrong.', message: "No active user found. Logging you out." });
      // TODO: Do Logout
      return;
    }
    dispatch(showProgressLoader(false));
  }

  useEffect(() => {page_onLoad();}, [])

  return (
    <>
      <HtmlHead title={title} description={description} />
      {/* Title and Top Buttons Start */}
      <div className="page-title-container">
        <Row>
          {/* Title Start */}
          <Col md="7">
            <h1 className="mb-0 pb-0 display-4">{title}</h1>
            <BreadcrumbList items={breadcrumbs} />
          </Col>
          {/* Title End */}

          {/* Top Buttons Start */}
          {/* 
          <Col md="5" className="d-flex align-items-start justify-content-end">
            <Button variant="outline-primary" className="btn-icon btn-icon-start btn-icon w-100 w-md-auto ms-1">
              <CsLineIcons icon="email" /> <span>Contact</span>
            </Button>
            <Dropdown align="end">
              <Dropdown.Toggle as={Button} variant="outline-primary" className="btn-icon btn-icon-only ms-1 dropdown-toggle-no-arrow">
                <CsLineIcons icon="more-horizontal" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="#/action-1">Follow</Dropdown.Item>
                <Dropdown.Item href="#/action-1">Hire</Dropdown.Item>
                <Dropdown.Item href="#/action-1">Report</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
          
          {/* Top Buttons End */}
        </Row>
      </div>
      {/* Title and Top Buttons End */}
      
      {/* Portfolio Start*/}
      <Portfolio user={currentUser}/>
      {/* Portfolio End */}
    </>
  );
};

export default PortfolioHome;